export default __webpack_public_path__ + "resources/icons/n410-b30d.webp";